module.exports = __webpack_public_path__ + "img/reservatorio.7caa96a7.svg";